import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import api from "@/api/bp";

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async fields(params: any) {
    return api.fields(params);
  }

  @Action
  async wjSubmitData(params: any) {
    return api.wjSubmitData(params);
  }

  @Action
  async wjSubmitDetail(params: any) {
    return api.wjSubmitDetail(params);
  }

  @Action
  async bindData(params: any) {
    return api.bindData(params);
  }

  @Action
  async unbindData(params: any) {
    return api.unbindData(params);
  }
}
